export interface CaseStudyPlaceholder {
  id: number;
  title: string;
  sector: string;
  location: string;
  scope: string;
  risksManaged: string;
  outcomes: string;
}

export const CASE_STUDY_PLACEHOLDERS: CaseStudyPlaceholder[] = [
  {
    id: 1,
    title: "[Project Title]",
    sector: "[sector]",
    location: "[location]",
    scope: "[scope]",
    risksManaged: "[risks managed]",
    outcomes: "[outcomes]",
  },
  {
    id: 2,
    title: "[Project Title]",
    sector: "[sector]",
    location: "[location]",
    scope: "[scope]",
    risksManaged: "[risks managed]",
    outcomes: "[outcomes]",
  },
  {
    id: 3,
    title: "[Project Title]",
    sector: "[sector]",
    location: "[location]",
    scope: "[scope]",
    risksManaged: "[risks managed]",
    outcomes: "[outcomes]",
  },
  {
    id: 4,
    title: "[Project Title]",
    sector: "[sector]",
    location: "[location]",
    scope: "[scope]",
    risksManaged: "[risks managed]",
    outcomes: "[outcomes]",
  },
  {
    id: 5,
    title: "[Project Title]",
    sector: "[sector]",
    location: "[location]",
    scope: "[scope]",
    risksManaged: "[risks managed]",
    outcomes: "[outcomes]",
  },
  {
    id: 6,
    title: "[Project Title]",
    sector: "[sector]",
    location: "[location]",
    scope: "[scope]",
    risksManaged: "[risks managed]",
    outcomes: "[outcomes]",
  },
];
